// extracted by mini-css-extract-plugin
module.exports = {"icomoon-font":"Loader_icomoon-font__3UUSK","Loader":"Loader_Loader__10AMb","LoaderVisible":"Loader_LoaderVisible__9CvY3"};